<script>
import { store } from "./store.vue";

/**
 * Anzeige der Übersicht aller Selfservices als Boxen, bei denen schwebende oder noch nicht von Pensus abgerufene Änderungen vorliegen.
 * @displayName Offene Aufträge für Selfservices
 */
export default {
  name: "AuftraegeSelfService",
  components: {},
  props: {
    nurOffene: Boolean,
    fuerMitarbeiter: Boolean,
    MitarbeiterID: {
      type: String,
      default: "",
    },
    inBearbeitung: Object,
    unversandt: Object,
  },
  emits: ["update:inBearbeitung", "update:unversandt"],
  data() {
    return {
      store,
    };
  },
  mounted() {
    this.chckUnbearbeitet();
  },
  computed: {
    ServicesMain() {
      return this.getServices();
    },
    ServicesSub() {
      return this.getServices(true);
    },
  },
  methods: {
    getIndexSumString(Mitarbeiter) {
      //Sting für die Erlaubten Selfservices
      //Gesamtstring
      let sumString = "";
      let PMNRs = Mitarbeiter?.Versorgungen?.PMNR ?? false;
      let pmnrArr = [];
      let verSich = [];
      if (PMNRs) {
        //Versorgungen raussuchen und zum Array machen
        pmnrArr = Array.isArray(PMNRs) ? PMNRs : [PMNRs];
        //darin alle Versicherungen raussuchen und in das Array einhängen
        pmnrArr.forEach((p) => {
          sumString = sumString + p.PSELF ?? "";
          let vers = p?.Versicherungen?.VERSNR ?? false;
          if (vers) {
            verSich = verSich.concat(Array.isArray(vers) ? vers : [vers]);
          }
        });
        //dann alle VSELF zusammenfügen
        verSich.forEach((v) => {
          sumString = sumString + v.VSELF ?? "";
        });
      }
      return sumString;
    },
    getServices(subData = false) {
      //let filtered = JSON.stringify(store.selfService); // Objekt kopieren
      let filtered = {};
      //filtered = JSON.parse(filtered);
      const keys = Object.keys(store.selfService);
      keys.forEach((key) => {
        let e = store.selfService[key];
        if (
          (!this.nurOffene ||
            this.unversandt[key] ||
            this.inBearbeitung[key]) && // Übergabeparameter, ob nur offene oder alle Services anzuzeigen sind.
          // nötige Ausschlusskriterien für Services Masterdaten
          !subData && // Die Funktion wird einmal für MasterData und einmal für SubData aufgerufen - Hier MasterData
          ((this.fuerMitarbeiter &&
            e.conditionHide.indexOf("notMitarbeiterspezifisch") >= 0) ||
            (!this.fuerMitarbeiter &&
              e.conditionHide.indexOf("notMitarbeiterspezifisch") < 0)) &&
          e.image.length > 0 && //es muss ein Bild da sein
          (e.conditionHide.indexOf("goLive") < 0 || !store.goLive) && //golive darf nicht geforder sein ODER wir sind NICHT goLive
          (e.conditionHide.indexOf("notAnwaerter") < 0 ||
            this.$servertalk.checkAnwaerter()) && //nur für Anwäerter oder er ist Anwärter
          (e.conditionHide.indexOf("anwaerter") < 0 ||
            this.$servertalk.checkAnwaerter() === false) && //nicht für Anwäerter oder er ist kein Anwärter
          (e.conditionHide.indexOf("notRentner") < 0 ||
            this.$servertalk.checkRentner()) && //nur für Rentner
          //(e.conditionHide.indexOf("notVerbotFirma") < 0 ||
          //  this.$servertalk.checkVerbotFirma() === false) && //nur erlaubte Firmen // Nicht mehr relevant EA / 29.07.2026
          this.$servertalk.isSelfserviceAllowed(key) && // Freigabe per PERSSELF / PMSELF EA / 29.07.2026
          (e.conditionHide.indexOf("privat") < 0 || !this.checkPrivat()) && // nicht privat versichert
          (e.conditionHide.indexOf("Steuernummer") < 0 ||
            store.satzart !== "person" ||
            store.masterData.data.Stammdaten?.STEUERIDNR.length <= 0) && //keine Steuernummer oder er hat keine
          e.conditionHide.indexOf(store.satzart) < 0 && // Wenn gesetzt, nicht für person / ansprechpartner
          e.conditionHide.indexOf("firmaNotSelected") < 0
        ) {
          filtered[key] = e;
        }

        //Block für Subdata
        if (  
          (!this.nurOffene ||
            this.unversandt[key] ||
            this.inBearbeitung[key]) && // Übergabeparameter, ob nur offene oder alle Services anzuzeigen sind.
          // nötige Ausschlusskriterien für Services Subdaten
          subData && // Die Funktion wird einmal für MasterData und einmal für SubData aufgerufen - Hier SubData
          ((this.fuerMitarbeiter &&
            e.conditionHide.indexOf("notMitarbeiterspezifisch") >= 0 && // Für jeden mitarbeiterspezifischen Service muss die erforderliche Berechtigung "ident" im String "IDENT" enthalten sein.
            this.getIndexSumString(store.xSelectedMitarbeiter).indexOf(
              e.ident
            ) >= 0) ||
            (!this.fuerMitarbeiter &&
              e.conditionHide.indexOf("notMitarbeiterspezifisch") < 0)) &&
          e.image.length > 0 && //es muss ein Bild da sein
          (e.conditionHide.indexOf("goLive") < 0 || !store.goLive) && //golive darf nicht gefordert sein ODER wir sind NICHT goLive
          e.conditionHide.indexOf("firmaNotSelected") >= 0 &&
          store.subData.data?.Firmenstammdaten?.FNAME
        ) {
          filtered[key] = e;
        }
      });

      this.$servertalk.doLog("filtered:");
      this.$servertalk.doLog(filtered);
      return filtered;
    },
    checkPrivat() {
      let _versorgung = false;
      let _kkData = false;
      if (typeof store.masterData.data.Versorgung === "object") {
        if (store.masterData.data.Versorgung.PMNR.length > 1) {
          _versorgung = store.masterData.data.Versorgung.PMNR[0];
        } else {
          _versorgung = store.masterData.data.Versorgung.PMNR;
        }
      }
      _kkData = _versorgung?.Krankenkasse ?? false;
      return "2" === _kkData.KKSTATUS; // Privat versichert
    },
    getInBearbeitung(index) {
      if (this.fuerMitarbeiter) {
        return false;
      } else {
        return this.inBearbeitung[index];
      }
    },
    getUnversandt(index) {
      if (this.fuerMitarbeiter) {
        let mService = store.subData.data?.sService[index];
        if (mService != undefined && this.MitarbeiterID != "") {
          let mykeys = Object.keys(mService || {});
          let isIn = mykeys.find(
            (key) => mService[key]?.PERSNR == this.MitarbeiterID
          );
          if (isIn == undefined) {
            return false;
          } else {
            return this.unversandt[index];
          }
        } else {
          return false;
        }
      } else {
        return this.unversandt[index];
      }
    },
    chckUnbearbeitet() {
      let inB = this.inBearbeitung;
      let unV = this.unversandt;
      for (const [key] of Object.entries(inB)) {
        inB[key] =
          this.$servertalk.gettAttr(
            "subData.draft.sService.Entwuerfe." + key
          ) == "modified" ||
          this.$servertalk.gettAttr(
            "masterData.draft.sService.Entwuerfe." + key
          ) == "modified";
        unV[key] =
          this.$servertalk.checkForUnsentSelfService(key) ||
          this.$servertalk.checkForUnsentSelfService(key, store.subData);
      }
      this.$emit("update:inBearbeitung", inB);
      this.$emit("update:unversandt", unV);
    },
  },
};
</script>
<template>
  <div v-for="(service, index) in ServicesMain" :key="index + '-1'"
    class="item group relative hover:scale-[102%] transition-all duration-500" tabindex="0">
    <router-link active-class="font-bold" :to="service.url" class="block" :class="{
      'pointer-events-none cursor-default opacity-50':
        store.masterData.isReadOnly,
    }">
      <div class="item-image relative [&>img]:min-h-[240px] [&>img]:object-cover">
        <img :src="service.image" :alt="`Bild ${service.title}`" />
        <div v-if="getInBearbeitung(index)" class="status-label absolute top-0 right-0">
          <span class="bearbeitung bg-yellow-500 text-tertiary block py-1 px-2 text-sm uppercase">
            Entwurf
          </span>
        </div>
        <div v-if="getUnversandt(index)" class="status-label absolute top-0 left-0">
          <span class="unversandt bg-green-500 text-white block py-1 px-2 text-sm uppercase">
            In Auftrag
          </span>
        </div>
      </div>
      <div class="item-text bg-tertiary/80 group-hover:bg-tertiary absolute bottom-0 w-full">
        {{ service.title }}
      </div>
    </router-link>
  </div>
  <div v-for="(service, index) in ServicesSub" :key="index + '-2'"
    class="item group relative hover:scale-[102%] transition-all duration-500">
    <router-link active-class="font-bold" :to="service.url" class="block" tabindex="0" :class="{
      'pointer-events-none cursor-default opacity-50':
        store.subData.isReadOnly || store.selectedFirma?.VERMITTLER == 1,
    }">
      <div class="item-image relative [&>img]:min-h-[240px] [&>img]:object-cover">
        <img :src="service.image" :alt="`Bild ${service.title}`" />
        <div v-if="getInBearbeitung(index, 'sub')" class="status-label absolute top-0 right-0">
          <span class="bearbeitung bg-yellow-500 text-tertiary block py-1 px-2 text-sm uppercase">
            Entwurf
          </span>
        </div>
        <div v-if="getUnversandt(index, 'sub')" class="status-label absolute top-0 left-0">
          <span class="unversandt bg-green-500 text-white block py-1 px-2 text-sm uppercase">
            In Auftrag
          </span>
        </div>
      </div>
      <div class="item-text bg-primary/80 group-hover:bg-primary absolute bottom-0 w-full" :class="{
        'bg-primary/80 group-hover:bg-primary':
          !service.conditionHide.includes('kunde'),
        'bg-tertiary/80 group-hover:bg-tertiary':
          service.conditionHide.includes('kunde'),
      }">
        {{ service.title }}
      </div>
    </router-link>
  </div>
</template>
